
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class OrderReceiptGrid extends Serenity.EntityGrid<OrderReceiptRow, any> {
        protected getColumnsKey() { return 'ECommerce.OrderReceipt'; }
        protected getDialogType() { return OrderReceiptDialog; }
        protected getIdProperty() { return OrderReceiptRow.idProperty; }
        protected getInsertPermission() { return OrderReceiptRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderReceiptRow.localTextPrefix; }
        protected getService() { return OrderReceiptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}